import React, { FunctionComponent, ChangeEvent } from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

type CheckBoxProps = { name: string; label: string; className: string; checked: boolean; onChange: Function };

const CheckBox: FunctionComponent<CheckBoxProps> = (props) => {
    const { name, label, onChange, className, checked } = props;

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked, event.target.name);
    };

    return (
        <FormGroup>
            <FormControlLabel
                classes={{
                    label: className,
                }}
                control={<Checkbox checked={checked} onChange={handleChange} name={name} color="primary" />}
                label={label}
            />
        </FormGroup>
    );
};

export default CheckBox;
